import { storage } from '@guardian/libs';
function isRecord(item) {
    return item != null && !Array.isArray(item) && typeof item === 'object';
}
function getGlobal(path = '') {
    const value = path
        .replace(/^window.guardian./, '')
        .replace(/\[(.+?)\]/g, '.$1')
        .split('.')
        .reduce((config, key) => {
        if (isRecord(config)) {
            return config[key];
        }
        return config;
    }, window.guardian);
    if (value) {
        return value;
    }
    return null;
}
function getLocal(path = '') {
    // feature flags path is in the format 'featureSwitches.featureFlagName' and we want to
    // extract the 'featureFlagName' part to check if there is an override in local storage
    if (!storage.local.isAvailable()) {
        return null;
    }
    const [flag] = path.split('.').slice(-1);
    try {
        const value = flag && storage.local.get(flag);
        if (value) {
            return value;
        }
        return null;
    }
    catch (e) {
        console.error(`Failed to read overrides for flag "${flag}" from path "${path}":`, e);
        return null;
    }
}
export const emptySwitches = {
    experiments: {},
    oneOffPaymentMethods: {},
    recurringPaymentMethods: {},
    subscriptionsSwitches: {},
    featureSwitches: {},
    campaignSwitches: {},
    recaptchaSwitches: {},
};
const getSettings = () => {
    const globalSettings = getGlobal('settings');
    const defaultSettings = {
        switches: emptySwitches,
        contributionTypes: {
            GBPCountries: [],
            UnitedStates: [],
            EURCountries: [],
            AUDCountries: [],
            International: [],
            NZDCountries: [],
            Canada: [],
        },
        metricUrl: '',
    };
    return globalSettings ?? defaultSettings;
};
const isSwitchOn = (switchName) => {
    const localOverride = switchName.startsWith('featureSwitches.')
        ? getLocal(switchName)
        : null;
    const sw = localOverride ?? getGlobal(`settings.switches.${switchName}`);
    return sw === 'On';
};
export { getGlobal, getSettings, isSwitchOn };
